import styled from 'styled-components';
import Tokens from '@grnhse/seedling/lib/birch/tokens';
import { Body } from '@grnhse/seedling/lib/birch/typography';

export const ErrorBody = styled(Body)`
  color: ${Tokens.colors.error};
`;

export const LogoContainer = styled.div`
  flex-shrink: 0;

  img {
    display: block;
    max-height: 96px;
    max-width: 96px;
  }
`;
